import { createGlobalStyle } from "styled-components";

const Reset = createGlobalStyle(() => {
  return {
    body: {
      margin: 0,
    },
  };
});

export default Reset;
